import LAYOUT from "@/layout/index.vue";

export const basicRoutes = [
  {
    path: "/",
    redirect: "/home", // 重定位后页面加载的页面
  },
  {
    path: "/home",
    component: LAYOUT,
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home/home.vue"),
      },
    ],
  },
  {
    path: "/module",
    component: LAYOUT,
    children: [
      {
        path: "module-text",
        component: () => import("@/views/module/moduleText.vue"),
      },
      {
        path: "module-detail",
        component: () => import("@/views/module/moduleTextDetail.vue"),
      },
      {
        path: "search",
        component:()=> import("@/views/module/search.vue"),
      },
      {
        path: "consultation",
        component:()=> import("@/views/module/consultation.vue"),
      }
    ],
  },
];

export const menuRoutes = [
  
];
